import { ENDPOINT } from 'api/endPoints/getSharedResourcesForOverlappingActivities';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    ISharedResourcesAvailabilityProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE } from 'components/Dashboards/Reporting/reportingConfig';

export const sharedResourcesAvailability: IHashmapItemWithCustomProps<ISharedResourcesAvailabilityProps> = {
    componentKey: 'sharedResourcesAvailability',
    title: 'Shared Resources Congestion Risk',
    id: 'shared-resources-availability',
    NoPermissionMessage,
    reportStyle: {
        widgetSizesAvailable: {
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: LARGE,
    },
    endpoint: ENDPOINT,
};
